import { useMemo } from 'react';
import { UsersQueries } from '@frontend/api-users';
import { useSchedulingLocationInfo } from '../../../../../../hooks/use-scheduling-location-info';

export const useScheduleRequestContextValue = ({
  refetchScheduleRequestList,
}: {
  refetchScheduleRequestList: () => void;
}) => {
  const { isMultiLocation } = useSchedulingLocationInfo();
  const { data: locationUsers } = UsersQueries.useGetUsers({
    params: isMultiLocation ? { showChildren: true } : {},
    opts: {
      cacheTime: 10 * 60 * 1000, // 10 mins
      staleTime: 10 * 60 * 1000, // 10 mins
    },
  });

  const providerValue = useMemo(
    () => ({
      locationUsers,
      refetchScheduleRequestList,
    }),
    [locationUsers, refetchScheduleRequestList]
  );

  return { providerValue };
};
